import { createContext, useContext, useCallback } from 'react';

// Create context for the scroll container ref
const ScrollContainerContext = createContext(null);

// Custom hook to use the scroll container ref
export const useScrollContainer = () => {
  const containerRef = useContext(ScrollContainerContext);
  
  // scrollTo function that matches native scrollTo API
  const scrollTo = useCallback((optionsOrX, y) => {
    if (containerRef?.current) {
      if (typeof optionsOrX === 'number') {
        // Support scrollTo(0, 100) format
        containerRef.current.scrollTo(optionsOrX, y);
      } else {
        // Support scrollTo({ top: 0, behavior: 'smooth' }) format
        containerRef.current.scrollTo(optionsOrX);
      }
    }
  }, [containerRef]);
  
  return { containerRef, scrollTo };
};

export default ScrollContainerContext;